// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"c0e91183","443":"c95cd87e","610":"7edfd30c","694":"7ad7078f","979":"b6ff761c"}[chunkId] + ".chunk.js";
};